export default "__VITE_ASSET__yaoTX5Kl__"